// @flow
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closePlusOverlay, getSubscriptions } from '@finect/front-core/User';
import { PlusOverBox } from './PlusOverBox';

const mapStateToProps = state => ({
  user: state.user.user,
  overlay: state.user.plusOverlay
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      closePlusOverlay,
      getSubscriptions
    },
    dispatch
  )
});

type Props = {
  user: Object,
  overlay: Object,
  actions: Object,
  url: string
};

const PlusLimitModal = ({ user, overlay, actions, url }: Props) => {
  const { plus: isPlus } = user;

  if (!overlay.hasOwnProperty('show') || isPlus) return null;

  return <PlusOverBox url={url} data={overlay} closePlusOverlay={actions.closePlusOverlay} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(PlusLimitModal);
